import { render } from "./TemplateTagsModal.vue?vue&type=template&id=5531be72&scoped=true"
import script from "./TemplateTagsModal.vue?vue&type=script&lang=js"
export * from "./TemplateTagsModal.vue?vue&type=script&lang=js"

import "./TemplateTagsModal.vue?vue&type=style&index=0&id=5531be72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5531be72"]])

export default __exports__